import React from 'react';
import { TDR } from 'tdr-common';
import { TableTag } from './TableTag';

type TableTagsProps = {
	attributes: TDR.Attributes.Attributes;
	guestCount?: string;
};

const TableTagsComponent: React.FC<TableTagsProps> = ({ attributes, guestCount }) => {
	return (
		<div className="flex p-1 gap-3">
			{guestCount && <TableTag label={guestCount} iconName='Profile2User' />}
			{Object.values(attributes)
				.flat(2)
				.slice(0, 2)
				.map((attributeValue: TDR.Attributes.OptionValue, index: number) => {
					const isLastTag = index === Object.values(attributes).flat(2).slice(0, 2).length - 1;
					return <TableTag
						label={attributeValue}
						key={`${attributeValue}-${index}`}
						iconName={TDR.Attributes.IconMapping[attributeValue]}
						classNames={isLastTag ? 'grow-0 min-w-0' : ''}
					/>;
				})}
		</div>
	);
};

export const TableTags = React.memo(TableTagsComponent);
